export default "./dist/stdassets/images/icons/edit-xml.png";